import { MLHelper } from '@bimser/core';

export function getCollectionTitle(
	sourceArray: Array<any>,
	path: string,
	maxRenderCount: number = 3
) {
	return sourceArray && Array.isArray(sourceArray)
		? sourceArray
				.slice(0, maxRenderCount)
				.map(item => (typeof item === 'string' ? item : MLHelper.getMLText(item[path])))
				.join(', ') + (sourceArray.length > 3 ? ', [..]' : '')
		: null;
}
